import { render, staticRenderFns } from "./emotionReq.vue?vue&type=template&id=56463128&scoped=true&"
import script from "./emotionReq.vue?vue&type=script&lang=js&"
export * from "./emotionReq.vue?vue&type=script&lang=js&"
import style0 from "./emotionReq.vue?vue&type=style&index=0&id=56463128&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56463128",
  null
  
)

export default component.exports